
import { QueryDispatcher } from "@/modules/shared/domain/QueryDispatcher";
import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";
import { BankAccountTransactions } from "./BankAccountTransactions";


export class SetTransactionStateDoneToDraftCommand {
    
    constructor(
        private readonly dispatcher: CommandDispatcher,
        private readonly q_dispatcher: QueryDispatcher,
        private frontend
    ) {}
    
    async run(transaction_ids:[string], bank_account_id:string|number, listFilters?): Promise<any> {
        let args = {
            bank_account_id: bank_account_id,
            transaction_ids: transaction_ids,
        }

        this.frontend.loading_update_state_done_draft = true
        try {
            await this.dispatcher.dispatch('set.transaction.state.done.to.draft', args)
            await new BankAccountTransactions(this.q_dispatcher, this.frontend).run_filter(bank_account_id, listFilters, this.frontend.$refs.bankSimpleFilters.option_selected, this.frontend.limit, this.frontend.offset)
        } catch (error) {
            console.error('Error update transactions state to done externally', error)
        }
        this.frontend.loading_update_state_done_draft = false
    }
}